module.exports = __webpack_public_path__ + "img/certificate_left.5d738503.jpg";